export default __webpack_public_path__ + "4b9cec11f9813cba35ce627fba2561f9.png";